import React, { useState, useEffect } from "react";
import { uploadFile, uploadProduct } from "../../DAL/create";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  TextField,
  MenuItem,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import SVGAAnimation from "../../Components/SVGAAnimation";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchCategoriesList,
  fetchProductDetail,
  GetProductDetail,
} from "../../DAL/fetch";
import { fileUrl } from "../../Config/Config";
import { updateSingleProductData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

function AddProduct() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [fileName, setFileName] = useState("");
  const [file2, setFile2] = useState(null);
  const [fileName2, setFileName2] = useState("");
  const [fileUploaded1, setFileUploaded1] = useState(false);
  const [fileUploaded2, setFileUploaded2] = useState(false);
  const [fileURL1, setFileURL1] = useState("");
  const [fileURL2, setFileURL2] = useState("");
  const [filePreview, setFilePreview] = useState(null);
  const [filePreview2, setFilePreview2] = useState(null);
  const [name, setName] = useState("");
  const [prices, setPrices] = useState({ 1: "", 7: "", 15: "", 30: "" });
  const [categoryId, setCategoryId] = useState("");
  const [categories, setCategories] = useState([]);
  const [type, setType] = useState("");
  const [enrtance, setEntrance] = useState("Small");
  const [types, setTypes] = useState("add");
  const [message, setMessage] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await GetProductDetail(id);
        if (response?.data?.data) {
          const product = response?.data?.data;
          setName(product?.name || "");
          setCategoryId(product?.category?.id || "");
          setType(product?.type || "");
          setEntrance(product?.entranceEffectType || "");
          setPrices({
            1: product?.prices?.daily,
            7: product?.prices?.weekly,
            15: product?.prices?.fifteenDays,
            30: product?.prices?.monthly,
          });
          setFileURL1(product?.picture?.id || "");
          setFileURL2(product?.animation?.id || "");
          if (product?.picture) {
            setFilePreview(fileUrl + product?.picture?.url);
          }
          if (product?.animation) {
            setFilePreview2(fileUrl + product?.animation?.url);
          }
          setTypes("edit");
        }
      } catch (error) {
        console.error("Failed to fetch product details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetchCategoriesList();
        const data = response.data.data;
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile ? selectedFile.name : "");
    setFileUploaded1(false);
    setFilePreview(URL.createObjectURL(selectedFile));
  };

  const handleFileChange2 = (e) => {
    const selectedFile2 = e.target.files[0];

    setFile2(selectedFile2);
    setFileName2(selectedFile2 ? selectedFile2.name : "");
    setFileUploaded2(false);
    setFilePreview2(URL.createObjectURL(selectedFile2));
  };

  const handleFileSubmit1 = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage(true);
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    setLoading(true);
    try {
      const imagedata = await uploadFile(formData);
      setFileURL1(imagedata.data.id);
      setFileUploaded1(true);
      enqueueSnackbar("File uploaded successfully!", {
        variant: "success",
      });
    } catch (error) {
      console.error("Error uploading file:", error);
      enqueueSnackbar("Failed to upload file. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFileSubmit2 = async (e) => {
    e.preventDefault();
    if (!file2) {
      enqueueSnackbar("Please select a second file first!", {
        variant: "error",
      });
      return;
    }

    const formData = new FormData();
    formData.append("image", file2);

    setLoading2(true);
    try {
      const animationdata = await uploadFile(formData);
      setFileURL2(animationdata.data.id);
      setFileUploaded2(true);
      enqueueSnackbar("Second file uploaded successfully!", {
        variant: "success",
      });
    } catch (error) {
      console.error("Error uploading second file:", error);
      enqueueSnackbar("Failed to upload second file. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading2(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      name,
      pictureId: fileURL1,
      animationId: fileURL2,
      categoryId,
      prices,
      type,
      entranceEffectType: enrtance,
    };

    setLoading(true);
    try {
      const resp =
        types == "add"
          ? await uploadProduct(payload)
          : await updateSingleProductData(id, payload);

      if (resp?.status == 200 || resp?.status == 201) {
        enqueueSnackbar(
          types == "add"
            ? "Product added successfully"
            : "Product updated successfully",
          { variant: "success" }
        );
        navigate("/products");
      } else {
        enqueueSnackbar(
          resp?.message ||
            resp?.error ||
            resp?.data?.message ||
            resp?.data?.error,
          { variant: "error" }
        );
      }
    } catch (error) {
      console.error("Error uploading product:", error);
      enqueueSnackbar("Failed to upload product. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "center",
        maxWidth: 400,
        margin: "auto",
        mt: 4,
      }}
    >
      <Typography variant="h6">
        {types == "add" ? "Create New Product" : "Update Product"}
      </Typography>
      <TextField
        fullWidth
        required
        label="Product Name"
        variant="outlined"
        value={name}
        onChange={(e) => setName(e.target.value)}
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      />
      {/* <FormHelperText sx={{ color: "red" }}>
        {message == true && !file && " Product name is required"}
      </FormHelperText> */}
      <FormControl fullWidth required sx={inputStyles}>
        <InputLabel sx={labelStyles}>Product Type</InputLabel>
        <Select
          value={type}
          label="Product Type"
          onChange={(e) => setType(e.target.value)}
        >
          {[
            "data_card",
            "frame",
            "effect",
            "entrance_effect",
            "batch",
            "background",
            "nickname",
            "theme",
          ].map((option) => (
            <MenuItem key={option} value={option}>
              {option.replace(/_/g, " ")}{" "}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {type == "entrance_effect" && (
        <FormControl fullWidth required sx={inputStyles}>
          <InputLabel sx={labelStyles}>Entrance Type</InputLabel>
          <Select
            value={enrtance}
            label="Entrance Type"
            onChange={(e) => setEntrance(e.target.value)}
          >
            {["Big", "Small"].map((option) => (
              <MenuItem key={option} value={option}>
                {option.replace(/_/g, " ")}{" "}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      {/* <FormHelperText sx={{ color: "red" }}>
        {message == true && !file && " Product type is required"}
      </FormHelperText> */}
      <TextField
        select
        fullWidth
        required
        label="Select Category"
        value={categoryId}
        onChange={(e) => setCategoryId(e.target.value)}
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      >
        {categories.map((category) => (
          <MenuItem key={category.id} value={category.id}>
            {category.name}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        fullWidth
        required
        label="Daily Price"
        variant="outlined"
        type="number"
        value={prices[1]}
        inputProps={{ min: 0 }}
        onChange={(e) =>
          setPrices({
            ...prices,
            1: e.target.value === "" ? "" : Number(e.target.value),
          })
        }
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      />

      <TextField
        fullWidth
        required
        label="Weekly Price"
        variant="outlined"
        type="number"
        value={prices[7]}
        inputProps={{ min: 0 }}
        onChange={(e) =>
          setPrices({
            ...prices,
            7: e.target.value === "" ? "" : Number(e.target.value),
          })
        }
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      />

      <TextField
        fullWidth
        required
        label="15days Price"
        variant="outlined"
        type="number"
        value={prices[15]}
        inputProps={{ min: 0 }}
        onChange={(e) =>
          setPrices({
            ...prices,
            15: e.target.value === "" ? "" : Number(e.target.value),
          })
        }
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      />

      <TextField
        fullWidth
        required
        label="Monthly Price"
        variant="outlined"
        type="number"
        value={prices[30]}
        inputProps={{ min: 0 }}
        onChange={(e) =>
          setPrices({
            ...prices,
            30: e.target.value === "" ? "" : Number(e.target.value),
          })
        }
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
      />

      <Typography variant="h6">Upload Image *</Typography>

      <Box sx={{ width: "100%", display: "flex", gap: 2 }}>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        <Button
          variant="contained"
          color={fileUploaded1 ? "success" : "primary"}
          onClick={handleFileSubmit1}
          disabled={loading || !file}
          sx={{ textTransform: "none" }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : fileUploaded1 ? (
            "Uploaded"
          ) : (
            "Upload"
          )}
        </Button>
      </Box>
      {fileName && <Typography variant="body2">{fileName}</Typography>}
      {/* <FormHelperText sx={{ color: "red" }}>
        {message == true && !file && "Image file is required"}
      </FormHelperText> */}

      {filePreview && (
        <Box sx={{ mt: 2 }}>
          <img
            src={filePreview}
            alt="Preview"
            style={{ maxWidth: "100%", maxHeight: "200px" }}
          />
        </Box>
      )}

      <Typography variant="h6">Upload Animation SVGA *</Typography>

      <Box sx={{ width: "100%", display: "flex", gap: 2 }}>
        <input type="file" accept=".svga" onChange={handleFileChange2} />
        <Button
          variant="contained"
          color={fileUploaded2 ? "success" : "primary"}
          onClick={handleFileSubmit2}
          disabled={loading2 || !file2}
          sx={{ textTransform: "none" }}
        >
          {loading2 ? (
            <CircularProgress size={24} color="inherit" />
          ) : fileUploaded2 ? (
            "Uploaded"
          ) : (
            "Upload"
          )}
        </Button>
      </Box>
      {/* {fileName2 && <Typography variant="body2">{fileName2}</Typography>} */}
      {/* <FormHelperText sx={{ color: "red" }}>
        {message == true && !file && "SVGA file is required"}
      </FormHelperText> */}
      {filePreview2 && (
        <Box mt={2} sx={{ backgroundColor: "#ccc", borderRadius: "13px" }}>
          <SVGAAnimation animationUrl={filePreview2} />
        </Box>
      )}

      {/* {<SVGAAnimation animationUrl={filePreview2} />} */}

      <Button
        variant="contained"
        className="gradientButton"
        onClick={handleSubmit}
        fullWidth
        sx={{ marginBottom: "20px", textTransform: "none" }}
      >
        Submit
      </Button>
    </Box>
  );
}

export default AddProduct;
